"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAttributeValueByName = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const client_utils_1 = require("../../../client/client.utils");
const hooks_1 = require("../../../../hooks");
const useGetAttributeValueByName = ({ productTreeNodeId }) => {
    const { addError } = (0, hooks_1.useNotification)();
    const [fetchAttributeValueByName,] = (0, react_2.useLazyQuery)(gql_1.GET_ATTRIBUTE_VALUE_BY_NAME);
    const loadAttributionInfo = (0, react_1.useCallback)((attributeName, valueName) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const response = yield fetchAttributeValueByName({
                variables: {
                    attributeName,
                    valueName,
                    skipValues: !valueName,
                    productTreeNodeId,
                },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(response);
            const { label, description, values } = (_e = (_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.productTreeNode) === null || _b === void 0 ? void 0 : _b.labelValidation) === null || _c === void 0 ? void 0 : _c.edges[0]) === null || _d === void 0 ? void 0 : _d.node) !== null && _e !== void 0 ? _e : {};
            const { value, description: valueDescription } = (_g = (_f = values === null || values === void 0 ? void 0 : values.edges[0]) === null || _f === void 0 ? void 0 : _f.node) !== null && _g !== void 0 ? _g : {};
            const attributionInfo = {
                label,
                labelDescription: description,
                value,
                valueDescription,
            };
            return attributionInfo;
        }
        catch (e) {
            addError(e.message, e.stack);
            return null;
        }
    }), [addError, fetchAttributeValueByName, productTreeNodeId]);
    return {
        loadAttributionInfo,
    };
};
exports.useGetAttributeValueByName = useGetAttributeValueByName;
